import React from "react";
import { NavLink } from "react-router-dom";
import arrow_back from "../../images/arrow_back.png";
const survey = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <NavLink to="/signup">
              {" "}
              <span>
                <img
                  src={arrow_back}
                  alt="arrow_back"
                  className="img-fluid arrow-back"
                />
              </span>
            </NavLink>{" "}
            <span className="optional">** Selection not required</span>
            <h3 className="header-signup">
              What would you like <br></br>to use Cuppycode for?
            </h3>
            <div className="tacking">
              <input
                className="radio"
                type="radio"
                id="html"
                name="fav_language"
                value="Copy Bet codes and win"
              />
                <label className="l1">Copy Bet codes and win</label>
               {" "}
              <input
                className="radio"
                type="radio"
                id="css"
                name="fav_language"
                value="Sell Bet codes / Premium package"
              />
                <label className="l1">Sell Bet codes / Premium package</label>
               {" "}
              <input
                className="radio"
                type="radio"
                id="javascript"
                name="fav_language"
                value="All of the Above"
              />
                <label className="l1">All of both listed</label>
            </div>
            <div className="col-9">
              <button className="btn-cuppy">Create Account</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default survey;
